const PENDING_AWS_EXTERNAL_ID_KEY = 'pending_aws_external_id';
const PENDING_AWS_CONNECTION_KEY = 'pending_aws_connection';

export type PendingAwsConnection = {
  externalId: string;
  dataSourceId?: number;
  consoleUrl?: string;
};

function canUseStorage(): boolean {
  return typeof window !== 'undefined';
}

export function savePendingAwsExternalId(externalId: string): void {
  if (!canUseStorage()) return;
  window.localStorage.setItem(PENDING_AWS_EXTERNAL_ID_KEY, externalId);
}

export function readPendingAwsExternalId(): string | null {
  if (!canUseStorage()) return null;
  const fromKey = window.localStorage.getItem(PENDING_AWS_EXTERNAL_ID_KEY);
  if (fromKey) return fromKey;
  const pending = readPendingAwsConnection();
  return pending?.externalId ?? null;
}

export function clearPendingAwsExternalId(): void {
  if (!canUseStorage()) return;
  window.localStorage.removeItem(PENDING_AWS_EXTERNAL_ID_KEY);
  window.localStorage.removeItem(PENDING_AWS_CONNECTION_KEY);
}

export function savePendingAwsConnection(connection: PendingAwsConnection): void {
  if (!canUseStorage()) return;
  window.localStorage.setItem(PENDING_AWS_CONNECTION_KEY, JSON.stringify(connection));
  savePendingAwsExternalId(connection.externalId);
}

export function readPendingAwsConnection(): PendingAwsConnection | null {
  if (!canUseStorage()) return null;
  const raw = window.localStorage.getItem(PENDING_AWS_CONNECTION_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as PendingAwsConnection;
    if (!parsed || typeof parsed.externalId !== 'string' || !parsed.externalId) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}
